export const BETAVRM_URL = 'betavrm';
export const isBeta = () => {
    return window.location.href.includes(BETAVRM_URL);
};
